export const DefaultMeasurementType = "C";
export const DefaultTemporality = "3";

export enum CircuitBreakerValues {
  Phase1 = "1",
  Phase3 = "3",
}

export const ShowSlpcat = {
  MOO: ["1"],
  MOP: ["2"],
  VO: ["4"],
};

export enum TariffCustomerTypeValues {
  Household = "4",
  Company = "2",
}

export const CustomerPairing: { [key: string]: string } = {
  "1": "4",
  "2": "2",
  "4": "4",
};

export const PropertyRelation = [
  { label: "Majitel", value: "M" },
  { label: "Nájemce/Podnájemce", value: "N" },
];

export const DistributorIdGasnet = "GD-GASNET";
export const Tariff27 = ["D27D", "C27D"];
export const EonDistributors = ["ED-EON", "GD-EON"];
export const EonPreviousDistributors = ["ES-EON", "GS-EON", "ES-EON_LUM", "GS-EON_LUM"];
export const BundleServiceId = "S_KOMPLET_ZP_01";
export const BundleServiceIdHeatPump = "S_KOMPLET_EE_03";
export const BundleServiceIdFVE = "S_KOMPLET_EE_04";

export const CommodityIdElectricity = 1;
export const tariffsForVTyearConsumption = ["C01D", "C02D", "C03D", "C62D", "D01D", "D02D"];

export const BRAND = "BRAND";
export const KETTLE_BRAND = "KETTLE_BRAND";

export const is1TTariff = ["C01D", "C02D", "C03D", "D01D", "D02D", "C62D"];

export const DefaultEcoType = "M";
